import axios from 'axios'
import { parseDispositionFileName, withExportDate } from '@/utils/export-filename'

function readBlobText (blob) {
    return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = () => resolve(reader.result || '')
        reader.onerror = () => resolve('')
        reader.readAsText(blob)
    })
}

/** 下载群组成员文件，等待后端生成完成后再触发浏览器下载。 */
export function downloadSceneMembers (baseUrl, groupId, scope) {
    const url = `${baseUrl}/lechun-cms/scene/exportUserGroupMembers`
    return axios.get(url, {
        params: { groupId: groupId, scope: scope },
        responseType: 'blob',
        timeout: 180000,
        withCredentials: true
    }).then(async (response) => {
        const contentType = (response.headers && response.headers['content-type']) || ''
        if (contentType.indexOf('application/json') > -1 || contentType.indexOf('text/plain') > -1 || contentType.indexOf('text/html') > -1) {
            const message = await readBlobText(response.data)
            let parsed
            try { parsed = JSON.parse(message) } catch (e) { parsed = null }
            throw new Error((parsed && (parsed.message || parsed.error_msg)) || message || '导出失败')
        }
        const disposition = (response.headers && response.headers['content-disposition']) || ''
        const serverName = parseDispositionFileName(disposition)
        const rawName = serverName || `用户群组-${groupId}-用户名单.xlsx`
        const fileName = withExportDate(rawName)
        const blobUrl = window.URL.createObjectURL(response.data)
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
        return true
    })
}
